import { TimePicker } from "ant-design-vue";
const { ...other } = TimePicker;
import "./src/timePicker.less"

const YwTimePicker = {
	...other,
	name: "YwTimePicker",
};
YwTimePicker.install = function (Vue) { 
  Vue.component(YwTimePicker.name, TimePicker);
}

export default YwTimePicker;
